import React, { useState, useEffect } from "react";
import { Col, Row, Card, Button, Modal, Input, Select, message, Pagination, DatePicker, Tooltip, Tag, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import "./CareerDevelopmentCourses.css";
import { PlusOutlined, ClockCircleOutlined, BookOutlined, InboxOutlined, SearchOutlined } from '@ant-design/icons';
import Dragger from "antd/es/upload/Dragger";
import { Checkbox } from 'antd';
import axios from "axios";
import { BaseUrl } from "../../Components/Constants/Constants";

const CareerDevelopmentCourses = () => {
    const { RangePicker } = DatePicker;
    const navigate = useNavigate();

    const [courseModal, setCourseModal] = useState(false);
    const [courseValue, setCourseValue] = useState("");
    const [courses, setCourses] = useState([]);
    const [file, setFile] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [showInactive, setShowInactive] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(8);
    const [error, setError] = useState(null);
    const [courseStartDate, setCourseStartDate] = useState(null);
    const [courseEndDate, setCourseEndDate] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);
    const [selectedCourseId, setSelectedCourseId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const [loading, setLoading] = useState(true); // add loading state
    const [submitting, setSubmitting] = useState(false); // loading state for form submission

    const [groups, setGroups] = useState([]);
    const [groupValue, setGroupValue] = useState([]);
    const [groupsLoading, setGroupsLoading] = useState(false);

    // const [assignMode, setAssignMode] = useState(false);
    const [selectedCourseIds, setSelectedCourseIds] = useState([]);



    //   const mappedCourses = res.data.map(course => ({
    //     course_id: course.id,
    //     course_title: course.title,
    //     course_img: course.course_image_url || "",
    //     is_completed: course.is_completed,
    //     // duration_minutes: course.duration_minutes,
    //     created_at: course.created_at,
    //     progress: course.is_completed ? 100 : 0,
    //   }));
    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        setLoading(true); // start loading
        try {
            const res = await axios.get(
                `${BaseUrl}career-development/courses`,
                { withCredentials: true }
            );

            const mappedCourses = res.data.map(course => ({
                course_id: course.id,
                course_title: course.title,
                group_name: course.group?.name || "",
                course_img: course.course_image_url || "",
                is_completed: course.is_completed,
                // duration_minutes: course.duration_minutes,
                created_at: course.created_at,
                progress: course.is_completed ? 100 : 0,
            }));

            setCourses(mappedCourses);
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch courses");
        } finally {
            setLoading(false); // done loading
        }
    };



    useEffect(() => {
        if (courseModal) {
            fetchGroups();
        }
    }, [courseModal]);
    const fetchGroups = async () => {
        try {
            setGroupsLoading(true);

            const res = await axios.get(
                `${BaseUrl}career-development/getGroups`,
                { withCredentials: true }
            );

            const groupOptions =
                res.data?.map((group) => ({
                    label: group.name,
                    value: group.name, // keep name as value for tags mode
                })) || [];

            setGroups(groupOptions);
        } catch (error) {
            message.error("Failed to fetch groups");
        } finally {
            setGroupsLoading(false);
        }
    };


    const handleAddCourse = async () => {
        if (!courseValue.trim()) {
            setError("Course Title is required.");
            message.error("Please enter a course title");
            return;
        }
        // if (!courseStartDate || !courseEndDate) {
        //   message.error("Please select course duration");
        //   return;
        // }

        setSubmitting(true);

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('title', courseValue);
        formData.append('description', ''); // Empty description as in your original code
        formData.append('group_name', groupValue.join(', ')); // Join array into comma-separated string
        // formData.append(
        //   'duration_minutes',
        //   String(Math.ceil((new Date(courseEndDate) - new Date(courseStartDate)) / 60000))
        // );

        // Add file if exists (only the first file from fileList)
        if (fileList.length > 0) {
            formData.append('file', fileList[0].originFileObj);
        }

        try {
            const res = await axios.post(
                `${BaseUrl}career-development/create-courses`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            // Add the new course immediately to the state
            setCourses(prev => [
                {
                    course_id: res.data.id,
                    course_title: res.data.title,
                    group_name: res.data.group_name,
                    course_img: res.data.course_image_url || "", // Use the uploaded image URL
                    is_active: !res.data.is_completed,
                    //   duration_minutes: res.data.duration_minutes,
                    created_at: res.data.created_at,
                    progress: res.data.is_completed ? 100 : 0,
                },
                ...prev
            ]);

            message.success("Course created successfully!");
            setCourseModal(false);
            resetForm();
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data && err.response.data.message) {
                message.error(
                    Array.isArray(err.response.data.message)
                        ? err.response.data.message.join(", ")
                        : err.response.data.message
                );
            } else {
                message.error("Failed to create course");
            }
        } finally {
            setSubmitting(false);
        }
    };

    const resetForm = () => {
        setCourseValue("");
        setFile([]);
        setFileList([]);
        setCourseStartDate(null);
        setCourseEndDate(null);
        setError(null);
    };

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            setCourseStartDate(dates[0]?.toISOString());
            setCourseEndDate(dates[1]?.toISOString());
        } else {
            setCourseStartDate(null);
            setCourseEndDate(null);
        }
    };

const handleCardClick = (course) => {
    navigate(`/careerdevelopmentcourses/${course.course_id}`, {
        state: { course }
    });
};



    const handlePaginationChange = (page) => {
        setCurrentPage(page);
    };

    const handleCheckboxChange = (e) => {
        setShowInactive(e.target.checked);
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const cancelCourseModal = () => {
        setCourseModal(false);
        resetForm();
    };

    // Filter courses by active/inactive status and search query
    const filteredCourses = courses.filter(course => {
        const matchesStatus = showInactive
            ? course.is_completed
            : !course.is_completed;

        const query = searchQuery.trim().toLowerCase(); // ✅ define query

        const matchesSearch =
            query === "" ||
            course.course_title?.toLowerCase().includes(query) ||
            course.group_name?.toLowerCase().includes(query); // ✅ OR condition

        return matchesStatus && matchesSearch;
    });

    const currentPageSize = currentPage === 1 ? 7 : 8;
    const paginatedCourses = filteredCourses.slice(
        currentPage === 1 ? 0 : (7 + (currentPage - 2) * 8),
        currentPage === 1 ? 7 : (7 + (currentPage - 1) * 8)
    );


    // const toggleAssignMode = () => {
    //     setAssignMode(prev => !prev);
    //     setSelectedCourseIds([]); // reset selection when toggling
    // };

    const toggleCourseSelection = (courseId) => {
        setSelectedCourseIds(prev =>
            prev.includes(courseId)
                ? prev.filter(id => id !== courseId)
                : [...prev, courseId]
        );
    };

    const handleAssignNavigation = () => {
        if (selectedCourseIds.length === 0) {
            message.warning("Please select at least one module");
            return;
        }

        navigate(`/careercourseassign/${selectedCourseIds.join(",")}`);
    };


    return (
        <div className="courses-container">
            {/* Header */}
            <div className="courses-header">
                <div className="header-content">
                    <div className="title-section">
                        <h1 className="page-title"><BookOutlined className="title-icon" /> Modules</h1>
                        <p className="page-subtitle"> Manage and track all your learning courses </p>
                    </div>
                    <div className="header-actions">
                        <Input.Search
                            placeholder="Search modules..."
                            allowClear
                            enterButton={<SearchOutlined />}
                            size="large"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ width: 300, marginRight: 16 }}
                            className="course-search-input"
                        />
                        <Checkbox onChange={handleCheckboxChange} className="inactive-checkbox">
                            <span className="checkbox-label"> Show Inactive Modules </span>
                        </Checkbox>
                        {/* <Button
                            type={assignMode ? "primary" : "default"}
                            onClick={toggleAssignMode}
                            style={{ marginLeft: 12 }}
                        >
                            Assign Module
                        </Button> */}


                    </div>
                </div>
            </div>


            {/* Add Course Modal */}
            <Modal
                open={courseModal}
                title={
                    <div className="modal-header">
                        <PlusOutlined className="modal-icon" />
                        <span>Create New Module</span>
                    </div>
                }
                onCancel={cancelCourseModal}
                footer={[
                    <Button key="cancel" onClick={cancelCourseModal} size="large" disabled={submitting}>
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleAddCourse}
                        size="large"

                        loading={submitting}
                        disabled={submitting}
                        style={submitting ? { opacity: 1 } : {}}
                    >
                        {submitting ? "Creating..." : "Create Module"}
                    </Button>,
                ]}
                width={600}
                className="course-modal"
            >
                <div className="modal-content">
                    <div className="form-group">
                        <label className="form-label">
                            Module Title <span className="required">*</span>
                        </label>
                        <Input
                            placeholder="Enter module title"
                            value={courseValue}
                            onChange={(e) => {
                                setCourseValue(e.target.value);
                                setError(null);
                            }}
                            size="large"
                            status={error ? "error" : ""}
                            prefix={<BookOutlined className="input-icon" />}
                        />
                        {error && <div className="error-message">{error}</div>}
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Course Group <span className="required">*</span>
                        </label>

                        <Select
                            mode="tags"
                            size="large"
                            style={{ width: "100%" }}
                            placeholder="Select or type a new group name"
                            value={groupValue}
                            onChange={setGroupValue}
                            options={groups}
                            loading={groupsLoading}
                            maxTagCount="responsive"
                        />
                    </div>



                    {/* <div className="form-group">
            <label className="form-label">
              Course Duration <span className="required">*</span>
            </label>
            <RangePicker
              onChange={handleDateChange}
              size="large"
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
            />
          </div> */}

                    {/* File Upload Field */}
                    <div className="form-group">
                        <label className="form-label">Upload Cover Image</label>
                        <Dragger
                            multiple={false}
                            maxCount={1}
                            accept="image/*"
                            showUploadList
                            listType="text"
                            beforeUpload={(file) => {
                                setFileList([{
                                    ...file,
                                    name: file.name, originFileObj: file
                                }]); // Replace the array, don't append
                                return false; // Prevent auto-upload
                            }}
                            fileList={fileList}
                            onRemove={(file) => {
                                setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
                            }}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag files to this area to upload</p>
                            <p className="ant-upload-hint">Upload cover image for your module.</p>
                        </Dragger>
                    </div>
                </div>
            </Modal>

            {/* Courses Grid */}
            <div className="courses-grid">
                {!showInactive && currentPage === 1 && (
                    <div className="course-card add-course-card" onClick={() => setCourseModal(true)}>
                        <div className="add-course-content">
                            <div className="add-course-icon-wrapper"><PlusOutlined className="add-course-icon" /></div>
                            <h3 className="add-course-title">Create new Module</h3>
                            <p className="add-course-description"> Start building your learning content </p>
                        </div>
                        <div className="card-shine"></div>
                    </div>
                )}
                {loading ? (
                    <div className="loading-placeholder">Loading courses...</div>
                ) : paginatedCourses.length > 0 ? (
                    paginatedCourses.map((course, index) => (
                        <div
                            key={course.course_id}
                            className={`course-card ${hoveredCard === index ? 'hovered' : ''}`}
                            onClick={() => handleCardClick(course)}
                            onMouseEnter={() => setHoveredCard(index)}
                            onMouseLeave={() => setHoveredCard(null)}
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    top: 12,
                                    left: 12,
                                    zIndex: 2
                                }}
                                onClick={(e) => e.stopPropagation()} // prevent card click
                            >
                                <Checkbox
                                    checked={selectedCourseIds.includes(course.course_id)}
                                    onChange={() => toggleCourseSelection(course.course_id)}
                                />
                            </div>

                            <div className="course-card-image-wrapper">
                                <img src={course.course_img} alt={course.course_title} className="course-card-image" />
                            </div>
                            <div className="course-card-content">
                                <Tooltip title={course.course_title}>
                                    <h3 className="course-card-title">{course.course_title}</h3>
                                </Tooltip>
                                <div className="course-card-meta">
                                    <div className="meta-item">
                                        <span className="meta-text">{course.group_name}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="card-shine"></div>
                        </div>

                    ))
                ) : (
                    <div className="empty-state">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                            <div className="empty-description">
                                <h3>No courses found</h3>
                                <p>
                                    {searchQuery.trim()
                                        ? `No courses match "${searchQuery}"`
                                        : showInactive
                                            ? "You don't have any inactive courses"
                                            : "Create your first course to get started"
                                    }
                                </p>
                                {!showInactive && !searchQuery.trim() && (
                                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setCourseModal(true)} size="large" className="empty-action-btn">
                                        Create Course
                                    </Button>
                                )}
                                {searchQuery.trim() && (
                                    <Button onClick={() => setSearchQuery("")} size="large" className="empty-action-btn" style={{ marginTop: 8 }}>
                                        Clear Search
                                    </Button>
                                )}
                            </div>
                        } />
                    </div>
                )}
            </div>

            {/* Selected Courses Summary */}
            {selectedCourseIds.length > 0 && (
                <div className="assign-summary">
                    <span>{selectedCourseIds.length} module{selectedCourseIds.length > 1 ? "s" : ""} selected</span>
                    <Button
                        type="primary"
                        style={{ marginLeft: 16 }}
                        onClick={handleAssignNavigation}
                    >
                        Proceed
                    </Button>
                </div>
            )}

            {/* Pagination */}
            {filteredCourses.length > 7 && (
                <div className="pagination-wrapper">
                    <Pagination current={currentPage} pageSize={1} total={Math.ceil(filteredCourses.length > 7 ? 1 + Math.ceil((filteredCourses.length - 7) / 8) : 1)} onChange={handlePaginationChange} showSizeChanger={false} showTotal={(total, range) => `Page ${currentPage} of ${Math.ceil(filteredCourses.length > 7 ? 1 + Math.ceil((filteredCourses.length - 7) / 8) : 1)} pages`} />
                </div>
            )}
        </div>
    );
};

export default CareerDevelopmentCourses;
